export default {
  QUEUE: 'QUEUE',
  AGENT: 'USER',
  EXTERNAL_NUMBER: 'EXTERNAL_NUMBER',
} as const;
